import { useState } from "react";
import { toast } from "sonner";
import { Globe, Loader2, Sparkles, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { ToneSelect } from "@/components/composer/AiWriter";
import api, { errMsg } from "@/lib/api";

export default function VariantsEditor({ content, targets, variants, setVariants }) {
  const [tone, setTone] = useState("santai");
  const [busy, setBusy] = useState(false);

  const generate = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/ai/variations", { text: content, count: targets.length, tone });
      const next = {};
      targets.forEach((t, i) => { next[t.key] = data.variations[i]; });
      setVariants(next);
      toast.success(`${targets.length} variasi dijana`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center gap-2">
        <ToneSelect value={tone} onChange={setTone} testId="composer-variant-tone" />
        <Button type="button" size="sm" onClick={generate} disabled={busy || !content.trim() || targets.length === 0} className="bg-violet-600 hover:bg-violet-500" data-testid="composer-ai-rewrite-btn">
          {busy ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : <Sparkles className="mr-1.5 h-3.5 w-3.5" />} Jana {targets.length || ""} variasi AI
        </Button>
        {Object.keys(variants).length > 0 && (
          <Button type="button" size="sm" variant="ghost" onClick={() => setVariants({})} data-testid="composer-variants-reset-btn">Guna teks asal untuk semua</Button>
        )}
      </div>
      {targets.length === 0 && <p className="text-sm text-muted-foreground">Pilih sasaran dahulu.</p>}
      <div className="space-y-3">
        {targets.map((t) => (
          <div key={t.key} className="rounded-lg border border-border bg-background/60 p-3" data-testid={`composer-ai-variant-item-${t.key}`}>
            <p className="mb-2 flex items-center gap-1.5 text-xs font-semibold text-muted-foreground">
              {t.kind === "page" ? <Globe className="h-3.5 w-3.5 text-cyan-300" /> : <Users className="h-3.5 w-3.5 text-primary" />} {t.name}
              {variants[t.key] && <span className="ml-1 rounded bg-violet-500/15 px-1.5 py-0.5 text-[10px] text-violet-300">AI</span>}
            </p>
            <Textarea
              value={variants[t.key] ?? content}
              onChange={(e) => setVariants({ ...variants, [t.key]: e.target.value })}
              rows={4}
              className="bg-card text-sm"
              data-testid={`composer-variant-textarea-${t.key}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
